// extracted by mini-css-extract-plugin
module.exports = {"notice_box":"noticeList_notice_box__2PUgB","EmptyConet_CONT":"noticeList_EmptyConet_CONT__NB2-g"};